import styled from "styled-components";
import { COLOR_SYSTEM } from "../../../design/design-system";
import { SHADOW } from "../../../design/effects";

export const ReviewSectionContainer = styled.div`
  background: #fff;
  border-radius: 8px;
  padding: 0;
  margin-bottom: 16px;
`;

export const ReviewSectionBody = styled.div`
  margin-left: 0;

  /* 이미지 스타일 - 컨테이너를 넘지 않도록 */
  img {
    max-width: 100%;
    height: auto;
    display: block;
    margin: 12px 0;
  }

  /* 약품 이미지는 마진 제거 (S3 약품 이미지 URL 패턴) */
  img[src*="phai/drugs/pictures"] {
    margin: 0;
  }

  /* p 태그 스타일 - 기본 마진 조정 */
  p {
    margin: 4px 0;
    line-height: 1.6;
  }

  /* li 안의 p 태그는 더 작은 마진 */
  li p {
    margin: 2px 0;
  }

  /* li 안의 첫번째 p는 마진 제거 */
  li p:first-child {
    margin-top: 0;
  }

  /* li 안의 마지막 p는 마진 제거 */
  li p:last-child {
    margin-bottom: 0;
  }

  h1 {
    font-size: 24px;
    font-weight: 700;
    line-height: 1.3;
    margin: 20px 0 12px 0;
    word-wrap: break-word;
    word-break: break-word;
  }

  h2 {
    font-size: 20px;
    /* h3(600)와 굵기를 차등해 ##/### 위계를 명확히 함 */
    font-weight: 700;
    line-height: 1.3;
    margin: 16px 0 10px 0;
    word-wrap: break-word;
    word-break: break-word;
  }

  h3 {
    /* 본문(Body1=1.6rem=16px)<h3 17px<h2 20px. 굵기 600으로 본문(400)·h2(700)와 모두 구분 */
    font-size: 17px;
    font-weight: 600;
    line-height: 1.3;
    margin: 12px 0 8px 0;
    word-wrap: break-word;
    word-break: break-word;
  }

  strong {
    font-weight: 700;
  }

  em {
    font-style: italic;
  }

  ul,
  ol {
    margin: 8px 0;
    padding-left: 20px;
  }

  li {
    margin: 4px 0;
  }

  /*
   * 섹션 타이틀 스타일 ([약사용 보고서], [환자용 복약지도문] 등)
   *
   * 페이지 나눔 로직:
   * - 첫 번째로 표시되는 섹션 마커는 페이지 나눔 없음 (data-page-break="false")
   * - 두 번째 섹션 마커는 페이지 나눔 적용 (data-page-break="true")
   * - 예: 약사용 보고서가 숨겨지면 환자용 복약지도문이 첫 번째가 되어 페이지 나눔 없음
   */
  .section-title {
    display: block;
    font-weight: 600;
    margin: 20px 0 12px 0;
    font-size: 16px;
    color: ${COLOR_SYSTEM.get("Gray")[800]};
  }

  /* 두 번째 섹션 마커에만 페이지 나눔 적용 */
  .section-title[data-page-break="true"] {
    @media print {
      display: block !important;
      page-break-before: always !important;
      page-break-after: avoid !important;
      page-break-inside: avoid !important;
      break-before: page !important;
      break-after: avoid !important;
      break-inside: avoid !important;
    }
  }

  /* Badge 스타일 (섹션 배지) */
  .section-badge {
    background-color: #1a1a1a;
    color: #ffffff;
    padding: 4px 14px;
    border-radius: 15px;
    display: inline-block;
    margin: 12px 0 8px 0;
    font-size: 14px;
    font-weight: 600;
    text-decoration: none;

    /* 출력 시에는 잉크 절약을 위해 테두리 스타일로 변경 */
    @media print {
      display: inline-block !important;
      background-color: transparent !important;
      color: #1a1a1a !important;
      border: 2px solid #1a1a1a !important;
      padding: 3px 13px !important; /* border 두께만큼 padding 조정 */
    }
  }

  /* 페이지 나눔이 필요한 배지 */
  .section-badge[data-page-break="true"] {
    @media print {
      display: block !important;
      width: fit-content !important;
      page-break-before: always !important;
      page-break-after: avoid !important;
      page-break-inside: avoid !important;
      break-before: page !important;
      break-after: avoid !important;
      break-inside: avoid !important;
    }
  }

  /* 일반 하이라이트 mark 태그 스타일 (Badge가 아닌 텍스트 강조용) */
  mark {
    padding: 2px 4px;
    border-radius: 3px;

    @media print {
      print-color-adjust: exact !important;
      -webkit-print-color-adjust: exact !important;
      color-adjust: exact !important;
    }
  }

  /* Badge 스타일 - mark 태그 */
  mark[data-color="#1a1a1a"] {
    background-color: #1a1a1a;
    color: #ffffff;
    padding: 4px 14px;
    border-radius: 15px;
    display: inline-block;
    margin: 12px 0 8px 0;
    font-size: 14px;
    font-weight: 600;
    text-decoration: none;

    /* 출력 시에는 잉크 절약을 위해 테두리 스타일로 변경 */
    @media print {
      display: inline-block !important;
      padding: 3px 13px !important;
    }
  }

  /* 페이지 나눔이 필요한 mark 배지 */
  mark[data-color="#1a1a1a"][data-page-break="true"] {
    @media print {
      display: block !important;
      width: fit-content !important;
      page-break-before: always !important;
      page-break-after: avoid !important;
      page-break-inside: avoid !important;
      break-before: page !important;
      break-after: avoid !important;
      break-inside: avoid !important;
    }
  }

  /* DRP 섹션 스타일 - blockquote로 렌더링됨 */
  blockquote {
    background: ${COLOR_SYSTEM.get("Gray")[10]};
    border: 0.5px solid ${COLOR_SYSTEM.get("Gray")[200]};
    border-radius: 12px;
    padding: 0 12px;
    margin: 0px 0;

    @media print {
      print-color-adjust: exact !important;
      -webkit-print-color-adjust: exact !important;
      color-adjust: exact !important;
    }

    /* 중첩된 blockquote 방지 */
    blockquote {
      background-color: transparent;
      border-left: none;
      padding-left: 0;
    }
  }

  /* 테이블 스타일 */
  table {
    width: 100%;
    border-collapse: collapse;
    margin: 16px 0;
    border: 1px solid ${COLOR_SYSTEM.get("Gray")[200]};
    font-size: 12px;
    }

  thead {
  }

  th {
    padding: 6px 8px;
    text-align: left;
    font-weight: 600;
    border: 1px solid ${COLOR_SYSTEM.get("Gray")[200]};
    vertical-align: top;
    background-color: ${COLOR_SYSTEM.get("Gray")[50]};

    /* 인쇄 시엔 페이지 수 증가를 억제하기 위해 화면(6px 8px)보다 여백을 좁게 둔다 */
    @media print {
      padding: 4px 6px;
      print-color-adjust: exact !important;
      -webkit-print-color-adjust: exact !important;
      color-adjust: exact !important;
    }
  }

  td {
    padding: 6px 8px;
    border: 1px solid ${COLOR_SYSTEM.get("Gray")[200]};
    vertical-align: top;

    /* 인쇄 시엔 페이지 수 증가를 억제하기 위해 화면(6px 8px)보다 여백을 좁게 둔다 */
    @media print {
      padding: 4px 6px;
    }
  }
`;

// 상세 섹션 스타일
export const DetailSection = styled.div`
  margin-top: 40px;
`;

// 배지 스타일 (분석결과 요약 등)
export const Badge = styled.span`
  background-color: ${COLOR_SYSTEM.get("Gray")[900]};
  color: ${COLOR_SYSTEM.get("Gray")[0]};
  padding: 1px 12px;
  border-radius: 15px;
  font-size: 12px;
  font-weight: 600;
  display: inline-block;
  margin-top: 12px;
`;

// 이전 버전과의 호환성을 위한 별칭
export const SummaryBadge = Badge;

// 상담필요 배지 스타일 (노란색)
export const ConsultBadge = styled.span`
  background-color: ${COLOR_SYSTEM.get("Yellow")[50]};
  color: ${COLOR_SYSTEM.get("Yellow")[700]};
  padding: 2px 6px;
  border-radius: 15px;
  font-size: 10px;
`;

// 근거확인필요 배지 스타일 (주황색)
export const EvidenceBadge = styled.span`
  background-color: ${COLOR_SYSTEM.get("Orange")[50]};
  color: ${COLOR_SYSTEM.get("Orange")[600]};
  padding: 2px 6px;
  border-radius: 15px;
  font-size: 10px;
`;

// 편집 모드 스타일
export const EditContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;
  overflow: hidden;
`;

export const EditorWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
`;
